<button type="button" class="btn btn-default artie" [ngbPopover]="artieSaysTemplate"  popoverTitle="ARTie says" >
  <img src="../../assets/images/artie1.gif" alt="I'm ARTie">
</button>
<ng-template #artieSaysTemplate>
  {{artieSaysText}}
</ng-template>
